import type { ComponentProps } from 'react';
import WindowInterface from './Interface';

type Props = ComponentProps<typeof WindowInterface>;

/** Thin container — window logic remains inside Interface for this phase. */
export default function Container(props: Props) {
  return <WindowInterface {...props} />;
}
